import type { HrefLocation } from "./types";

/**
 * A destination as Operator reads it: same-origin as the root-relative path `navigate_to_page`
 * takes, external absolute.
 */
export const describeHref = ({ origin, pathname, search, hash, href }: HrefLocation): string =>
  origin === window.location.origin ? pathname + search + hash : href;
